export default __webpack_public_path__ + "static/media/baseline-location_on-24px.2f342a18.svg";